import { v4 as uuid } from 'uuid';

import { IPatient, v2, constants } from '../../..';
import { getDefaults } from './helpers/getDefaults';

export const noteAdapter = (patient: IPatient): v2.Note[] => {
    const { notes, postVisitNotes, postVisitNotesBuddy } = patient;

    const defaults = getDefaults(patient);

    const result: v2.Note[] = [];

    if (notes) {
        result.push({
            ...defaults,
            id: uuid(),
            text: notes,
            noteType: 'PRE_VISIT',
        });
    }

    if (postVisitNotes) {
        result.push({
            ...defaults,
            id: uuid(),
            createdById: constants.HCP1,
            text: postVisitNotes,
            noteType: 'POST_VISIT',
        });
    }

    if (postVisitNotesBuddy) {
        result.push({
            ...defaults,
            id: uuid(),
            createdById: constants.HCP2,
            text: postVisitNotesBuddy,
            noteType: 'POST_VISIT',
        });
    }

    return result;
};
